import { meta } from '@/helpers/constants/router';
import { OVERVIEW_ROUTE, STORES_ROUTE, CART_SETTINGS_ROUTE, PROMOS_ROUTE, CART_PROMOS_ROUTE, CART_PROMOS_NEW_ROUTE, CART_PROMOS_EDIT_ROUTE, DELIVERY_AREAS_ROUTE, DELIVERY_AREAS_NEW_ROUTE, DELIVERY_AREAS_EDIT_ROUTE, PROMOS_NEW_ROUTE, PROMOS_EDIT_ROUTE, ORDERS_ROUTE, BROADCAST_ROUTE, CUSTOMER_SEGMENT_ROUTE, PERFORMANCE_ROUTE, } from '@/helpers/constants/StoreManagementRoutes';
import { REBATES_SUBMISSIONS_ROUTE, REBATES_VOUCHERS_ROUTE, } from '@/helpers/constants/StoreAddOnsRoutes';
// lazy load components
// https://router.vuejs.org/guide/advanced/lazy-loading.html
const Wrapper = () => import('@/views/Wrapper.vue');
export default [
    {
        path: 'store-management',
        component: Wrapper,
        meta: { ...meta, title: 'Store Management' },
        children: [
            {
                path: 'overview',
                component: Wrapper,
                meta: { ...meta, title: OVERVIEW_ROUTE.title },
                children: [
                    {
                        path: '/',
                        component: Wrapper,
                        meta: {
                            title: 'Overview',
                            redirect: OVERVIEW_ROUTE.name,
                        },
                        children: [
                            {
                                path: '/',
                                name: OVERVIEW_ROUTE.name,
                                component: () => import('@/views/v2/store_management/Overview.vue'),
                                meta: {
                                    title: OVERVIEW_ROUTE.title,
                                },
                            },
                            {
                                path: 'most-visited-store',
                                name: 'most-visited-store',
                                component: () => import('@/views/v2/store_management/MostVisitedStoresIndex.vue'),
                                meta: { title: `Most Visited Store` },
                            },
                        ],
                    },
                    {
                        path: 'mini-app-performance',
                        component: Wrapper,
                        meta: {
                            title: PERFORMANCE_ROUTE.title,
                            redirect: PERFORMANCE_ROUTE.name,
                        },
                        children: [
                            {
                                path: '/',
                                name: PERFORMANCE_ROUTE.name,
                                component: () => import('@/views/v2/store_management/Performance.vue'),
                                meta: {
                                    title: PERFORMANCE_ROUTE.title,
                                },
                            },
                        ],
                    },
                ],
            },
            {
                path: 'stores',
                component: Wrapper,
                meta: { ...meta, title: STORES_ROUTE.title },
                children: [
                    {
                        path: '/',
                        name: STORES_ROUTE.name,
                        meta: {
                            title: STORES_ROUTE.title,
                        },
                        component: () => import('@/views/v2/store_management/Stores.vue'),
                    },
                ],
            },
            {
                path: 'cart',
                component: Wrapper,
                redirect: CART_SETTINGS_ROUTE.name,
                meta: { ...meta, title: CART_SETTINGS_ROUTE.title },
                children: [
                    {
                        path: 'settings',
                        name: CART_SETTINGS_ROUTE.name,
                        component: () => import('@/views/v2/ecommerce/CartSetting.vue'),
                        meta: {
                            title: CART_SETTINGS_ROUTE.title,
                            parentMenu: CART_SETTINGS_ROUTE.name,
                            subtitle: 'Manage your cart settings such as Delivery Fee, Free Shipping, ' +
                                'Minimum Purchase Amount, Address Input and Location Scope.',
                        },
                    },
                    {
                        path: 'promos',
                        component: Wrapper,
                        redirect: CART_PROMOS_ROUTE.name,
                        meta: { title: CART_PROMOS_ROUTE.title },
                        children: [
                            {
                                path: '/',
                                name: CART_PROMOS_ROUTE.name,
                                component: () => import('@/views/v2/apps/CartPromos.vue'),
                                meta: {
                                    title: CART_PROMOS_ROUTE.title,
                                    parentMenu: CART_SETTINGS_ROUTE.name,
                                    subtitle: 'Set free shipping, set minimum purchase amount, and freebies',
                                },
                            },
                            {
                                path: 'create',
                                name: CART_PROMOS_NEW_ROUTE.name,
                                component: () => import('@/views/v2/apps/CartPromoCreate.vue'),
                                meta: {
                                    title: CART_PROMOS_NEW_ROUTE.title,
                                    parentMenu: CART_SETTINGS_ROUTE.name,
                                },
                            },
                            {
                                path: ':uuid',
                                component: Wrapper,
                                meta,
                                children: [
                                    {
                                        path: 'edit',
                                        name: CART_PROMOS_EDIT_ROUTE.title,
                                        props: true,
                                        component: () => import('@/views/v2/apps/CartPromoEdit.vue'),
                                        meta: {
                                            title: CART_PROMOS_EDIT_ROUTE.title,
                                            parentMenu: CART_SETTINGS_ROUTE.name,
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
            {
                path: 'delivery-areas',
                component: Wrapper,
                redirect: DELIVERY_AREAS_ROUTE.name,
                meta: { ...meta, title: DELIVERY_AREAS_ROUTE.title },
                children: [
                    {
                        path: '/',
                        name: DELIVERY_AREAS_ROUTE.name,
                        component: () => import('@/views/v2/apps/DeliveryAreas.vue'),
                        meta: {
                            title: DELIVERY_AREAS_ROUTE.title,
                            subtitle: 'Manage your delivery locations',
                        },
                    },
                    {
                        path: 'create',
                        name: DELIVERY_AREAS_NEW_ROUTE.name,
                        component: () => import('@/views/v2/apps/DeliveryAreaCreate.vue'),
                        meta: { title: DELIVERY_AREAS_NEW_ROUTE.title },
                    },
                    {
                        path: ':uuid',
                        component: Wrapper,
                        meta,
                        children: [
                            {
                                path: 'edit',
                                name: DELIVERY_AREAS_EDIT_ROUTE.name,
                                props: true,
                                component: () => import('@/views/v2/apps/DeliveryAreaEdit.vue'),
                                meta: { title: DELIVERY_AREAS_EDIT_ROUTE.title },
                            },
                        ],
                    },
                ],
            },
            {
                path: 'promos',
                component: Wrapper,
                redirect: PROMOS_ROUTE.name,
                meta: { ...meta, title: PROMOS_ROUTE.title },
                children: [
                    {
                        path: '/',
                        name: PROMOS_ROUTE.name,
                        component: () => import('@/views/v2/apps/PromoCodes.vue'),
                        meta: {
                            title: PROMOS_ROUTE.title,
                            subtitle: 'Manage promo codes, coupon expiration and limit',
                        },
                    },
                    {
                        path: 'create',
                        name: PROMOS_NEW_ROUTE.name,
                        component: () => import('@/views/v2/apps/PromoCodeCreate.vue'),
                        meta: { title: PROMOS_NEW_ROUTE.title },
                    },
                    {
                        path: ':uuid',
                        component: Wrapper,
                        meta,
                        children: [
                            {
                                path: 'edit',
                                name: PROMOS_EDIT_ROUTE.name,
                                props: true,
                                component: () => import('@/views/v2/apps/PromoCodeEdit.vue'),
                                meta: { title: PROMOS_EDIT_ROUTE.title },
                            },
                        ],
                    },
                ],
            },
            {
                path: 'orders',
                component: Wrapper,
                meta: { ...meta, title: ORDERS_ROUTE.title },
                children: [
                    {
                        path: '/',
                        name: ORDERS_ROUTE.name,
                        meta: {
                            title: ORDERS_ROUTE.title,
                            subtitle: 'View All Orders from your Stores',
                        },
                        component: () => import('@/views/v2/store_management/MallOrderHistory.vue'),
                    },
                ],
            },
            {
                path: 'rebates',
                component: Wrapper,
                redirect: 'submissions-by-status',
                meta: { ...meta, title: REBATES_SUBMISSIONS_ROUTE.title },
                children: [
                    {
                        path: ':status',
                        component: () => import('@/views/v2/store_add_ons/rebates/Submissions.vue'),
                        children: [
                            {
                                path: '/',
                                name: 'submissions-by-status',
                                meta: { title: REBATES_SUBMISSIONS_ROUTE.title },
                                props: true,
                                component: () => import('@/views/v2/store_add_ons/rebates/SubmissionsByStatus.vue'),
                            },
                        ],
                    },
                ],
            },
            {
                path: 'vouchers',
                component: Wrapper,
                redirect: 'vouchers-by-status',
                meta: { ...meta, title: REBATES_VOUCHERS_ROUTE.title },
                children: [
                    {
                        path: ':status',
                        component: () => import('@/views/v2/store_add_ons/rebates/Vouchers.vue'),
                        children: [
                            {
                                path: '/',
                                name: 'vouchers-by-status',
                                meta: { title: REBATES_VOUCHERS_ROUTE.title },
                                props: true,
                                component: () => import('@/views/v2/store_add_ons/rebates/VouchersByStatus.vue'),
                            },
                        ],
                    },
                ],
            },
            {
                path: 'customers',
                component: Wrapper,
                meta: { ...meta, title: CUSTOMER_SEGMENT_ROUTE.title },
                children: [
                    {
                        path: '/',
                        name: CUSTOMER_SEGMENT_ROUTE.name,
                        meta: { title: CUSTOMER_SEGMENT_ROUTE.title },
                        component: () => import('@/views/v2/Customers.vue'),
                    },
                ],
            },
            {
                path: 'broadcast',
                component: Wrapper,
                meta: { ...meta, title: BROADCAST_ROUTE.title },
                children: [
                    {
                        path: '/',
                        name: BROADCAST_ROUTE.name,
                        meta: {
                            title: BROADCAST_ROUTE.title,
                            subtitle: 'Businesses will have up to 24 hours to respond to a user. Messages sent within the 24-hour window ' +
                                'may contain promotional content. We know people expect businesses to respond quickly, and ' +
                                'businesses that respond to users in a timely manner achieve better outcomes. We highly encourage ' +
                                'businesses to respond to people’s messages as soon as possible.',
                        },
                        component: () => import('@/views/v2/ComingSoon.vue'),
                    },
                ],
            },
            {
                path: 'notifications',
                name: 'store-management-notifications',
                component: () => import('@/views/v2/NotificationsManager.vue'),
                meta: { ...meta, title: 'Notification Manager' },
                redirect: { name: 'store-management-notifications-manager-email' },
                children: [
                    {
                        path: 'fb-messenger',
                        name: 'store-management-notifications-manager-fb-messenger',
                        meta: { title: 'Notification Manager', parentMenu: 'store-management-notifications' },
                        component: () => import('@/views/v2/NotificationsFbMessenger.vue'),
                    },
                    {
                        path: 'email',
                        name: 'store-management-notifications-manager-email',
                        meta: { title: 'Notification Manager', parentMenu: 'store-management-notifications' },
                        component: () => import('@/views/v2/NotificationsEmail.vue'),
                    },
                ],
            },
        ],
    },
];
